import React from 'react'
import { LayoutContact } from './layout/LayoutContact'


export const ContactScreen = () => {
    return (
        <LayoutContact />
    )
}
